import { CoreRankingsTable } from '../../../views';
import { RankingsRowTipping } from '../RankingsRow';

/**
 * @desc RankingsTipping Row Class
 * This class using on rankings page ('rankings/tipping')
 */
export class RankingsTableTipping extends CoreRankingsTable {

	get className() {
		return 'team-rankings league-table shadow';
	}

	get childView() {
		return RankingsRowTipping;
	}

	updateModel() {
		this.rounds.setFinalRound();
		const last_round_correct = this.rounds.last().get('id') === 29;
		if (this.rounds.last().get('status') === 'complete' && last_round_correct) {
			this.rounds.setFinalRoundAsComplete();
		}
		super.updateModel();

		return this;
	}
}

export default RankingsTableTipping;